import * as firebase from "firebase/app";
import "firebase/database";
import {firebaseConfig} from "config";

const app = firebase.initializeApp(firebaseConfig, "DS_APP");

declare global{
  interface Window {
    AnalyticsWebInterface: any;
  }
}

const dbPath = "prod/pincodes";
const dbNode = "pincode";

export enum firebaseEvents {
  APPLIED_FOR_LOAN = "APPLIED_FOR_LOAN",
}

export function checkPincodeValidity(pincode, callback) {
    firebase.database().ref()
    .child(dbPath).orderByChild(dbNode).equalTo(pincode).on("value", (snapShot) => {
        callback(snapShot.exists());
    });
}

let firebaseAnalytics: firebase.analytics.Analytics;

export const initFirebaseAnalytics = async (): Promise<firebase.analytics.Analytics> => {
  if (!firebaseAnalytics) {
    await require("firebase/analytics");
    firebaseAnalytics = await firebase.analytics(app);
  }
  return firebaseAnalytics;
}

export const logFirebaseEvent = async (apiVersion: number, eventName: string, eventParams?: {[key: string]: any}) => {
  if (!eventName) {
    return;
  }
  if (window.AnalyticsWebInterface && apiVersion > 195) {
    window.AnalyticsWebInterface.logEvent(eventName, JSON.stringify(eventParams));
  } else {
    const firebaseAnalytics = await initFirebaseAnalytics();
    firebaseAnalytics.logEvent(eventName, eventParams);
  }
}
